import React, { useState } from "react";
import { makeRequestAuth } from "../../_config/api";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import { FiX, FiBook } from "react-icons/fi";

export default function AddSubjectModal({ practiceId, onClose, onSuccess }) {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      showErrorToast("Subject name is required");
      return;
    }

    try {
      setLoading(true);
      // API call to add subject
      await makeRequestAuth("post", "/admin/addSubject", {
        practiceId: practiceId,
        name: name,
      });

      showSuccessToast("Subject added successfully");
      onSuccess(); // Close modal & refresh list
    } catch (error) {
      showErrorToast(error?.response?.data?.message || "Failed to add subject");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/60 backdrop-blur-sm transition-all">
      <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">
        {/* HEADER */}
        <div className="flex justify-between items-center px-6 py-4 border-b bg-gray-50">
          <div className="flex items-center gap-2">
            <div className="bg-purple-100 p-2 rounded-lg text-purple-600">
              <FiBook size={20} />
            </div>
            <h3 className="text-lg font-bold text-gray-800">Add Subject</h3>
          </div>
          <button
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-200 text-gray-500 transition"
          >
            <FiX size={20} />
          </button>
        </div>

        {/* BODY */}
        <form onSubmit={handleSubmit} className="p-6 space-y-5">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">
              Subject Name
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Physics, History"
              autoFocus
              className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
            />
            <p className="text-xs text-gray-500 mt-1">
              This subject will be added to the selected practice.
            </p>
          </div>

          {/* FOOTER ACTIONS */}
          <div className="flex flex-col sm:flex-row gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="order-2 sm:order-1 flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="order-1 sm:order-2 flex-1 px-4 py-2.5 bg-purple-600 hover:bg-purple-700 text-white rounded-lg shadow-lg shadow-purple-500/30 font-medium disabled:opacity-50 transition-all"
            >
              {loading ? "Adding..." : "Add Subject"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
